import { render, staticRenderFns } from "./template.vue?vue&type=template&id=be8b73ce&scoped=true&"
import script from "@/Components/Global/CompanyLogo/component.ts?vue&type=script&lang=ts&"
export * from "@/Components/Global/CompanyLogo/component.ts?vue&type=script&lang=ts&"
import style0 from "@/Components/Global/CompanyLogo/style.scss?vue&type=style&index=0&id=be8b73ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8b73ce",
  null
  
)

export default component.exports